import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { format, startOfDay } from "date-fns";
import { WEEKDAY_LABEL_FORMAT } from "web_myplann/Shared/Components/FlatRow/datePanelHelpers";
import { FlatRowDatePanelMonthHeader } from "web_myplann/Shared/Components/FlatRow/FlatRowDatePanelMonthHeader";
import { resolveInitialPanelDate } from "web_myplann/Shared/Components/FlatRow/resolveInitialPanelDate";
import { useDateFnsLocale } from "web_myplann/Shared/Hooks/useDateFnsLocale";

type Props = {
	value: Date | null;
	minDate?: Date;
	maxDate?: Date;
	onSelect: (date: Date) => void;
};

export const FlatRowDateDayPanel = ({
	value,
	minDate,
	maxDate,
	onSelect,
}: Props) => {
	const locale = useDateFnsLocale();

	return (
		<LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
			<DateCalendar
				value={value}
				referenceDate={resolveInitialPanelDate(value, minDate, maxDate)}
				minDate={minDate}
				maxDate={maxDate}
				views={["day"]}
				fixedWeekNumber={6}
				disableHighlightToday
				dayOfWeekFormatter={(day) =>
					format(day, WEEKDAY_LABEL_FORMAT, { locale })
				}
				slots={{
					calendarHeader: ({ currentMonth, onMonthChange }) => (
						<FlatRowDatePanelMonthHeader
							currentMonth={currentMonth}
							minDate={minDate}
							maxDate={maxDate}
							onMonthChange={onMonthChange}
						/>
					),
				}}
				onChange={(day) => {
					if (day === null) return;
					onSelect(startOfDay(day));
				}}
			/>
		</LocalizationProvider>
	);
};
